export default __webpack_public_path__ + "static/media/question-2.07c75260.svg";